var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"image-box__image",attrs:{"src":_vm.imageUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }